export default {
  "仅支持数字，座机需输入区号": "仅支持数字，座机需输入区号",
  "请输入7-13位的数字号码": "请输入7-13位的数字号码",
  "请输入号码": "请输入号码",
  "请输入正确的邮箱格式": "请输入正确的邮箱格式",
  "请先选择区号": "请先选择区号"
}
